/* Fredesigner visitor journey (card Claude-89). Loaded on every storefront page by
   snippets/fd-rewards-launcher.liquid, never in the theme editor.
   - Consent: Shopify's customer privacy API (consent-tracking-api). Nothing is sent and no visitor
     id is kept when the visitor refused analytics in the consent banner; with no choice yet it
     tracks; it re-checks on visitorConsentCollected. Until the API answers nothing is sent.
   - Visitor id: first-party cookie _fd_vid (random, 90 days sliding, SameSite=Lax, Secure, path /),
     so the checkout custom pixel can read it. Never added to the cart.
   - Events (whitelist only): page_view, product_option (select / radio choices on product pages,
     never typed text), add_to_cart, cart_view, checkout_click, rewards_open, rewards_signed_in,
     spin, referral_landing. No e-mail, address, phone or any typed value.
   - Sending: batches of at most 20 to /apps/fd-rewards/store/journey/collect, every 15 s while
     there are events and on pagehide / hidden (fetch keepalive, sendBeacon fallback). A JSON 404
     NOT_FOUND (service switched off) stops tracking for this tab. Errors are silent; nothing here
     blocks or waits for the page.
   - Linking: the store card's session token goes with one batch per browser session and token (a
     session cookie _fd_vjl holds a short hash of it, never the token); the service links this visitor
     id to the rewards account. A new token (another account, a new sign-in) is sent once again. */
(function(){
  'use strict';
  var w=window,d=document;
  if(w.__fdJourney)return;
  w.__fdJourney=true;
  try{if(w.Shopify&&w.Shopify.designMode)return;}catch(e){return;}
  var ENDPOINT='/apps/fd-rewards/store/journey/collect',COOKIE='_fd_vid',OFF_KEY='fd_vj_off_v1',LINK_KEY='fd_vj_link_v1',
    TOKEN_KEY='fd_rewards_store_token_v1',MAX_BATCH=20,MAX_QUEUE=100,EVERY_MS=15000,AGE_S=7776000,
    PRIZES=['spin5','spin10','reward500','shipping','reward100'];
  function store(name){try{var s=w[name];return s&&typeof s.getItem==='function'?s:null;}catch(e){return null;}}
  function sget(key){try{var s=store('sessionStorage');return s?s.getItem(key):null;}catch(e){return null;}}
  function sset(key,value){try{var s=store('sessionStorage');if(s)s.setItem(key,value);}catch(e){}}
  if(sget(OFF_KEY)==='1')return;

  var consent='pending',stopped=false,queue=[],timer=null,pausedUntil=0,signedIn=false,optionTimer=null,options={};

  // ---- small value rules (the service applies the same ones and drops anything else) ----
  var HANDLE=/^[a-z0-9][a-z0-9-]{0,99}$/,CAMPAIGN=/^[A-Za-z0-9 _.+\-]{1,60}$/,ALIAS=/^[a-z0-9](?:[a-z0-9-]{0,62}[a-z0-9])?$/;
  function shortText(value,max){
    if(typeof value!=='string')return null;
    var text=value.replace(/\s+/g,' ').trim();
    if(!text||text.length>max||/[\u0000-\u001f\u007f<>@]/.test(text))return null;
    if(text.replace(/[^0-9]/g,'').length>=7&&/[0-9][0-9 ().-]{5,}[0-9]/.test(text))return null;
    return text;
  }
  function cleanPath(path){
    if(typeof path!=='string'||path.charAt(0)!=='/')return '/';
    path=path.replace(/[\s"'<>\\@]/g,'');
    if(/^\/(?:account|checkouts?|orders|cart\/c|apps|tools|password|challenge)(?:\/|$)/.test(path))return '/'+path.split('/')[1];
    if(/^\/[0-9]+\/(?:invoices|orders|checkouts)\//.test(path))return '/'+path.split('/')[2];
    return path.slice(0,200);
  }
  function pageType(){
    var t=null;
    try{var entry=d.getElementById('fd-rewards-entry');t=entry&&entry.dataset?entry.dataset.page:null;}catch(e){}
    if(!t)try{t=w.ShopifyAnalytics.meta.page.pageType;}catch(e){}
    t=typeof t==='string'?t.toLowerCase().replace(/[^a-z_]/g,'_').slice(0,32):'';
    return /^[a-z_]{1,32}$/.test(t)?t:'other';
  }
  var PATH=cleanPath(w.location&&w.location.pathname),PAGE=pageType();
  var PRODUCT=(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([a-z0-9][a-z0-9-]{0,99})(?:\/|$)/.exec(PATH)||[])[1]||null;
  var COLLECTION=(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/([a-z0-9][a-z0-9-]{0,99})(?:\/|$)/.exec(PATH)||[])[1]||null;

  // ---- consent ----
  function decide(){
    var cp=null;try{cp=w.Shopify&&w.Shopify.customerPrivacy;}catch(e){}
    if(!cp)return 'unknown';
    try{
      if(typeof cp.currentVisitorConsent==='function'){
        var c=cp.currentVisitorConsent()||{};
        // Only an explicit "no" to analytics stops tracking; no choice yet means tracked.
        return c.analytics==='no'?'refused':'ok';
      }
      if(typeof cp.getTrackingConsent==='function')return cp.getTrackingConsent()==='no'?'refused':'ok';
    }catch(e){}
    return 'unknown';
  }
  // Until the API answers, nothing is sent (events wait in memory); if it never loads, nothing is sent.
  function applyConsent(){
    var result=decide();
    if(result==='unknown')return;
    if(result==='refused'){consent='refused';queue=[];dropCookie();return;}
    consent='ok';ensureVid();schedule();
  }

  // ---- visitor id ----
  function readVid(){var m=/(?:^|;\s*)_fd_vid=([A-Za-z0-9_-]{22,43})(?:;|$)/.exec(d.cookie||'');return m?m[1]:null;}
  function newVid(){
    var bytes=new Uint8Array(16),s='';w.crypto.getRandomValues(bytes);
    for(var i=0;i<bytes.length;i++)s+=String.fromCharCode(bytes[i]);
    return w.btoa(s).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
  }
  function ensureVid(){
    var id=readVid();
    try{if(!id)id=newVid();d.cookie=COOKIE+'='+id+'; Max-Age='+AGE_S+'; Path=/; SameSite=Lax; Secure';}catch(e){return null;}
    return id;
  }
  function dropCookie(){
    try{if(readVid())d.cookie=COOKIE+'=; Max-Age=0; Path=/; SameSite=Lax; Secure';}catch(e){}
    try{if(readLinkTag())d.cookie='_fd_vjl=; Max-Age=0; Path=/; SameSite=Lax; Secure';}catch(e){}
  }
  // The link marker for this browser session (a session cookie, shared by its tabs).
  function readLinkTag(){var m=/(?:^|;\s*)_fd_vjl=(t[0-9a-z]{1,13})(?:;|$)/.exec(d.cookie||'');return m?m[1]:null;}
  function saveLinkTag(tag){try{d.cookie='_fd_vjl='+tag+'; Path=/; SameSite=Lax; Secure';}catch(e){}sset(LINK_KEY,tag);}

  // ---- queue and sending ----
  function push(event){
    if(stopped||consent==='refused')return;
    event.at=Date.now();
    if(event.pageType===undefined)event.pageType=PAGE;
    if(event.path===undefined)event.path=PATH;
    queue.push(event);
    if(queue.length>MAX_QUEUE)queue.splice(0,queue.length-MAX_QUEUE);
    schedule();
  }
  function schedule(){
    if(timer||stopped||consent!=='ok'||!queue.length)return;
    timer=setTimeout(function(){timer=null;flush();},EVERY_MS);
  }
  function tokenTag(token){var h=5381;for(var i=0;i<token.length;i++)h=((h<<5)+h+token.charCodeAt(i))>>>0;return 't'+h.toString(36);}
  function storeToken(){
    try{var s=store('localStorage'),raw=s&&s.getItem(TOKEN_KEY),v=raw?JSON.parse(raw):null;
      return v&&typeof v.token==='string'&&/^[A-Za-z0-9_-]{43}$/.test(v.token)?v.token:null;}catch(e){return null;}
  }
  function stop(){stopped=true;queue=[];sset(OFF_KEY,'1');if(timer){clearTimeout(timer);timer=null;}}
  function send(payload){
    var text=JSON.stringify(payload),token=payload.token;
    var done=function(r){
      if(!r)return;
      if(r.status===404){r.json().then(function(b){if(b&&b.error==='NOT_FOUND')stop();},function(){});return;}
      if(r.status===429){pausedUntil=Date.now()+60000;return;}
      // Marked done only when the service says the link was queued (review C91 P3-5).
      if(r.status===202&&token)r.json().then(function(b){if(b&&b.linkQueued===true&&consent==='ok')saveLinkTag(tokenTag(token));},function(){});
    };
    try{
      if(typeof w.fetch==='function'){
        w.fetch(ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},body:text,keepalive:true,
          credentials:'omit',cache:'no-store'}).then(done,function(){});
        return;
      }
    }catch(e){}
    try{if(w.navigator&&w.navigator.sendBeacon)w.navigator.sendBeacon(ENDPOINT,new Blob([text],{type:'text/plain'}));}catch(e){}
  }
  function flush(){
    if(timer){clearTimeout(timer);timer=null;}
    if(stopped||consent!=='ok'||!queue.length||Date.now()<pausedUntil)return;
    var vid=readVid()||ensureVid();
    if(!vid)return;
    var token=storeToken(),tag=token&&tokenTag(token);
    var linkToken=token&&readLinkTag()!==tag&&sget(LINK_KEY)!==tag?token:null;
    while(queue.length){
      var payload={v:1,vid:vid,events:queue.splice(0,MAX_BATCH)};
      if(linkToken){payload.token=linkToken;linkToken=null;}
      send(payload);
    }
  }

  // ---- events ----
  function pageView(){
    var e={t:'page_view'},q=null;
    if(PRODUCT)e.product=PRODUCT;
    if(COLLECTION)e.collection=COLLECTION;
    try{if(d.referrer){var r=new URL(d.referrer);if(r.hostname&&r.hostname!==w.location.hostname)e.referrer=r.hostname.toLowerCase().slice(0,100);}}catch(x){}
    try{q=new URLSearchParams(w.location.search||'');}catch(x){}
    if(q){
      var utm={};
      ['source','medium','campaign'].forEach(function(k){var v=q.get('utm_'+k);if(v&&CAMPAIGN.test(v))utm[k]=v;});
      if(utm.source||utm.medium||utm.campaign)e.utm=utm;
      if(q.has('gclid'))e.gclid=true;
      if(q.has('fbclid'))e.fbclid=true;
    }
    push(e);
    var alias=q&&q.get('fdr');
    if(alias&&ALIAS.test(alias.toLowerCase()))push({t:'referral_landing',alias:alias.toLowerCase()});
  }
  function optionName(el){
    var name=null;
    try{
      name=el.getAttribute('data-option-name')||el.getAttribute('aria-label');
      if(!name&&el.type==='radio'&&el.closest){var fs=el.closest('fieldset'),lg=fs&&fs.querySelector('legend');name=lg&&lg.textContent;}
      if(!name&&el.id&&d.querySelector){var lb=d.querySelector('label[for="'+String(el.id).replace(/"/g,'')+'"]');name=lb&&lb.textContent;}
      if(!name&&el.name){var m=/\[([^\]]{1,60})\]$/.exec(el.name);name=m?m[1]:el.name;}
    }catch(e){}
    return shortText(name||'',60);
  }
  function onChange(e){
    if(PAGE!=='product')return;
    var el=e&&e.target;if(!el||!el.tagName)return;
    var tag=String(el.tagName).toLowerCase(),type=String(el.type||'').toLowerCase(),value=null;
    try{if(el.closest&&el.closest('#fd-rewards-overlay,form[action*="/account"],form[action*="/contact"],[data-fd-journey-ignore]'))return;}catch(x){}
    // Only choices: a select or a checked radio. Never a text, number, textarea or other typed field.
    if(tag==='select'){try{var o=el.options&&el.options[el.selectedIndex];value=o?o.text||o.value:el.value;}catch(x){}}
    else if(tag==='input'&&type==='radio'){if(!el.checked)return;value=el.value;}
    else return;
    var name=optionName(el);value=shortText(value||'',60);
    if(!name||!value)return;
    options[name]=value;
    if(optionTimer)clearTimeout(optionTimer);
    optionTimer=setTimeout(function(){optionTimer=null;for(var k in options)if(Object.prototype.hasOwnProperty.call(options,k))
      push({t:'product_option',product:PRODUCT||undefined,option:k,value:options[k]});options={};},800);
  }
  function readCart(then){
    try{w.fetch('/cart.js',{credentials:'same-origin',cache:'no-store'}).then(function(r){return r.ok?r.json():null;})
      .then(function(c){if(c)then(c);},function(){});}catch(e){}
  }
  var lastAdd=0;
  function cartAdded(){
    var at=Date.now();if(at-lastAdd<1500)return;lastAdd=at;
    readCart(function(c){
      var item=c&&c.items&&c.items[0];if(!item||!HANDLE.test(String(item.handle||'')))return;
      var e={t:'add_to_cart',product:item.handle,quantity:Math.max(1,Math.min(999,parseInt(item.quantity,10)||1))};
      if(Number.isSafeInteger(item.final_price)&&item.final_price>=0)e.unitCents=item.final_price;
      push(e);
    });
  }
  function watchCartAdds(){
    try{
      if(typeof w.PerformanceObserver!=='function')return;
      new w.PerformanceObserver(function(list){
        list.getEntries().forEach(function(en){if(/\/cart\/add(?:\.js)?(?:\?|$)/.test(String(en.name).replace(/^https?:\/\/[^/]+/,'')))cartAdded();});
      }).observe({type:'resource',buffered:false});
    }catch(e){}
    // A plain form post to /cart/add (no script took it over) leaves the page: record it from the form.
    d.addEventListener('submit',function(e){
      try{
        var f=e.target;if(e.defaultPrevented||!f||!/\/cart\/add/.test(String(f.getAttribute&&f.getAttribute('action')||'')))return;
        var qty=f.querySelector&&f.querySelector('[name="quantity"]'),n=qty?parseInt(qty.value,10):1;
        if(PRODUCT){push({t:'add_to_cart',product:PRODUCT,quantity:Math.max(1,Math.min(999,n||1))});flush();}
      }catch(x){}
    },false);
  }
  function onClick(e){
    try{
      var t=e&&e.target,hit=t&&t.closest&&t.closest('button[name="checkout"],input[name="checkout"],a[href*="/checkout"],[data-fd-checkout]');
      if(!hit)return;
      push({t:'checkout_click'});flush();
    }catch(x){}
  }
  function watchRewards(){
    signedIn=!!storeToken();
    d.addEventListener('fd-rewards:summary',function(e){
      var s=e&&e.detail;if(!s||typeof s!=='object')return;
      if(s.signedIn===true&&!signedIn){signedIn=true;push({t:'rewards_signed_in'});}
      else if(s.signedIn===false)signedIn=false;
    });
    d.addEventListener('fd-rewards:spin',function(e){var p=e&&e.detail&&e.detail.prize;if(PRIZES.indexOf(p)>=0)push({t:'spin',prize:p});});
    try{
      var dialog=d.getElementById('fd-rewards-overlay');
      if(dialog&&typeof w.MutationObserver==='function'){
        var open=!!dialog.open;
        new w.MutationObserver(function(){if(dialog.open&&!open)push({t:'rewards_open'});open=!!dialog.open;})
          .observe(dialog,{attributes:true,attributeFilter:['open']});
      }
    }catch(e){}
  }

  function start(){
    pageView();
    if(PAGE==='cart')readCart(function(c){if(Number.isSafeInteger(c.original_total_price))push({t:'cart_view',subtotalCents:c.original_total_price});});
    d.addEventListener('change',onChange,true);
    d.addEventListener('click',onClick,true);
    watchCartAdds();watchRewards();
    w.addEventListener('pagehide',flush);
    d.addEventListener('visibilitychange',function(){if(d.visibilityState==='hidden')flush();});
    d.addEventListener('visitorConsentCollected',function(){applyConsent();});
    try{
      if(w.Shopify&&typeof w.Shopify.loadFeatures==='function')
        w.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(){applyConsent();});
    }catch(e){}
    // The API may already be on the page: decide now, and look again in 3 s.
    applyConsent();
    setTimeout(function(){if(consent==='pending')applyConsent();},3000);
  }
  try{start();}catch(e){}
})();
